import _ from 'underscore';
import { serialize, parse, populateIds } from '@bingads-webui/odata-bulk-upsert';
import { edm } from '../environment/edm';

class BulkError extends Error {
  constructor({
    entity,
    errors,
  }) {
    super();
    this.entity = entity;
    this.errors = errors;
  }
}

export function getBulkUrl(params) {
  const { variables } = params;
  const { locator } = variables;
  const { descriptor } = locator;
  const { cid, aid } = descriptor;

  const entity = edm
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid);

  return `${entity.path}/Default.BulkUpsert`;
}

export function getBulkPayload(entitySchema, data) {
  const CsvRows = serialize(entitySchema, data);
  const payload = {
    CsvRows,
  };

  return payload;
}

export function getProcessedBulkResult(response, request) {
  const { data } = request;
  const csvData = parse(response);
  const {
    results,
    errors,
  } = csvData;

  const ret = populateIds(results, data);

  if (!_.isEmpty(errors)) {
    throw new BulkError({
      entity: ret,
      errors,
    });
  }

  return Array.isArray(ret) ? ret : [ret];
}
